<form
  *ngIf="docForm"
  [formGroup]="docForm"
  class="w-full flex justify-between items-center gap-2"
>
  <div
    class="w-56px h-56px flex justify-center items-center relative rounded-3px"
  >
    <img
      *ngIf="doc?.webcamImage?.imageAsDataUrl; else notPhotoTmpl"
      class="max-w-full max-h-full rounded-3px"
      [src]="doc.webcamImage.imageAsDataUrl"
    />

    <ng-template #notPhotoTmpl>
      <img
        *ngIf="doc?.isFileImage"
        class="max-w-full max-h-full"
        [src]="doc.base64"
      />
      <div
        *ngIf="doc?.isFilePdf"
        class="w-56px h-56px flex justify-center items-center"
      >
        <pdf-viewer
          *ngIf="document?.isFilePdf"
          [src]="pdfSrc"
          [render-text]="true"
          [show-all]="false"
          [page]="1"
          [original-size]="false"
          [fit-to-page]="true"
          style="width: 56px; height: 56px"
        ></pdf-viewer>
      </div>
      <span *ngIf="!doc?.isFileImage && !doc?.isFilePdf">{{
        doc.file.type
      }}</span>
    </ng-template>

    <div
      class="cursor-pointer rounded-3px bg-black bg-opacity-20 absolute top-0 right-0 left-0 bottom-0 flex justify-center items-center"
      (click)="showPreview = true"
    >
      <i class="material-icons text-white!">zoom_in</i>
    </div>
  </div>
  <ib-img-view
    *ngIf="showPreview"
    (closeMe)="showPreview = false"
    [document]="document"
  ></ib-img-view>

  <div class="grow relative">
    <mat-form-field>
      <mat-label>File name</mat-label>
      <input
        matInput
        id="{{ doc.id }}"
        formControlName="{{ FORM_FIELDS.DOC_NAME }}"
        placeholder="Type document name here"
      />
    </mat-form-field>
  </div>

  <div class="w-40px h-40px flex justify-center items-center">
    <button
      mat-button
      type="button"
      class="ib-btn ib-btn-icon ib-btn-icon-secondary"
      (click)="removeMe?.emit(doc.id)"
    >
      <i class="material-icons">close</i>
    </button>
  </div>
</form>

<ib-input-error
  *ngIf="docNameFormCtrl?.errors && docNameFormCtrl?.touched"
  class="ml-70px mt-inp-hint-mt"
  [formCtrl]="docNameFormCtrl"
>
</ib-input-error>
